import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { DiscussionDto } from '@workspace/data-types';
import { DiscussionSidebarCoreComponent } from '@workspace/ng-core-features';
import { UserStore } from '@workspace/ng-data-access';

@Component({
  selector: 'etxe-discussion-sidebar',
  imports: [CommonModule, DiscussionSidebarCoreComponent],
  host: {
    class: 'block h-full',
  },
  templateUrl: './discussion-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscussionSidebarComponent {
  private readonly userStore = inject(UserStore);

  discussions = input<DiscussionDto[]>([]);
  activeDiscussion = input<DiscussionDto | null>(null);
  isLoading = input<boolean>(false);
  timeFormat = input<string>('HH:mm');

  discussionSelected = output<DiscussionDto>();
  markAsUnread = output<{ discussion: DiscussionDto; event: Event }>();
  toggleStar = output<{ discussion: DiscussionDto; event: Event }>();
  archiveDiscussion = output<{ discussion: DiscussionDto; event: Event }>();
  filterTabChanged = output<'all' | 'unread' | 'archived'>();
  scrolledToBottom = output<void>();

  getParticipantName = (discussion: DiscussionDto): string => {
    const userId = this.userStore.current()?._id;
    const other = discussion.participants.find(
      (p) => userId && p.participant.toString() !== userId.toString(),
    );
    if (other?.firstName) {
      return other.firstName;
    }
    if (other?.participantType === 'owner' || other?.participantType === 'seller') {
      return 'Propriétaire Vendeur';
    }
    return 'Utilisateur';
  };

  getParticipantInitial = (discussion: DiscussionDto): string => {
    const name = this.getParticipantName(discussion);
    return name.charAt(0).toUpperCase();
  };
}
